import { Component, createRef, useEffect, useState } from "react";
import { Button } from "react-bootstrap"
import { connect, useDispatch, useSelector } from "react-redux";
import './MyBids.scss';
import { clock, lostface, medal } from "shared/assets/icons";
import { WonAndNotWonDatatable } from "shared/won-and-not-won-datatable/WonAndNotWonDatatable";
import store from "features/store";
import { convertToMaintainData, getMaintainData } from "shared/settings/stateMaintain";
import { Bidding } from "../auth-pages";
import { Helmet } from "react-helmet";
import { Breadcrumbs } from "shared/hoc/breadcrumbs/Breadcrumbs";
import { BREADCRUMB_TYPE_CONFIG } from "shared/hoc/breadcrumbs/config";
export const MyBidsFn = (props) => {

    const dispatch = useDispatch()
    const statemaintenance = useSelector(state => state?.statemaintenance);
    const userData = useSelector(state => state?.user);
    const toggleSignInModal = useSelector(state => state?.toggleSignInModal);
    const [loading, setLoading] = useState(true);
    const [noData, setNoData] = useState(true);
    const [activeBtnType, setActiveBtnType] = useState("active");
    const [deleteItemsList, setDeleteItemsList] = useState({});
    const [scrollTo, setScrollTo] = useState(0);
    const [isVisible, setIsVisible] = useState(false);
    const [pageClientWidth, setPageClientWidth] = useState(16);

    const maintainKey = `${activeBtnType ? activeBtnType : "active"}${props.history.location.pathname}`;
    const scrollRef = createRef();
    useEffect(() => {
        if ((userData?.id)) {
            checkandStateset()
        }  else {
            dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: true, mode: 'Sign-In', moveToHomeonCancel: true } });
            setActiveBtnType("")
        }
    }, [userData])
    const checkandStateset = ()=> {
        if (statemaintenance?.["MyBids"]) {
            if (statemaintenance?.["MyBids"]?.type != activeBtnType) {
                setActiveBtnType(statemaintenance?.["MyBids"]?.type)
                return
            }
        }
        setActiveBtnType("active")
    }
    useEffect(() => {
        setLoading(false);
        document.addEventListener('resize', resize)
    })
    useEffect(() => {
        if (toggleSignInModal?.moveToHomeonCancel && !toggleSignInModal?.open && !userData?.id) {
            dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: false, mode: 'Sign-In', moveToHomeonCancel: false } });
            props?.history.push("/")
        }
    }, [toggleSignInModal])

    const navigateToScreens = (type) => {
        let pusttoStore = { ...statemaintenance }
        delete pusttoStore["Activebids"] 
        delete pusttoStore["not-won-mybids"] 
        delete pusttoStore["won-mybids"] 
        pusttoStore["MyBids"] = {
            type:type
        }
        dispatch({
            type: 'PUSH_TO_STATE', payload: pusttoStore
        });
        setActiveBtnType(type);
    }

    const getItemsList = (event) => {
        setNoData(event.length === 0);
        if (event.scrollPage) {
            getPreviousValues();
        } else {
            store.dispatch({ type: 'SET_PREVIOUS_PATH', payload: { component: activeBtnType } });
        }
    }

    const getPreviousValues = () => {
        const previous = getMaintainData(maintainKey);
        if (previous) {
            scrollToPrevious();
            store.dispatch({ type: 'SET_PREVIOUS_PATH', payload: { component: activeBtnType } });
        }
    }

    const scrollToPrevious = () => {
        scrollRef.current.scrollTo({ top: this.state.scrollTo || 0, left: 0 });
    }

    const deleteItemList = (event) => {
        setDeleteItemsList(event);
    }

    const scrollToTop = () => {
        scrollRef.current.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }

    const resize = () => {
        setPageClientWidth(scrollRef?.current?.clientWidth);
    }

    const stateMaintenance = () => {
        const data = {
            scrollTo: scrollTo
        };
        convertToMaintainData(maintainKey, data);
    }

    const handleScroll = (event) => {
        try {
            const scrollTop = event?.target?.scrollTop;
            if (scrollTop) {
                setScrollTo(scrollTop);
                setPageClientWidth(this.scrollRef?.current?.clientWidth);
                setIsVisible((event.target.scrollHeight / 4) < event.target.scrollTop);
            } else {
                setPageClientWidth(this.scrollRef?.current?.clientWidth);
                setIsVisible((event.target.scrollHeight / 4) < event.target.scrollTop);
            }
        } catch (error) {
            return error;
        }
    }

    return (
        <div className="mybids-container"> 
            <Helmet>
                <title>CTBids | {"My Bids"}</title>
            </Helmet>
            <Breadcrumbs props={props} type={BREADCRUMB_TYPE_CONFIG.MYBIDS} />

         <div className="headnavbar p-4">

    </div>
            <div className="d-flex justify-content-center  align-items-center text-center">
                <div>
                    <div className="mybidshead">My Bids</div>
                    <div>
                        <div className="d-flex gap-3 mt-3">
                            <div className="btn-resp-bids">
                                <Button variant={activeBtnType == "active" ? 'secondary' : 'outline-steel'} className={`${activeBtnType == "active" ? 'bids-btn-active' : ''} head-btn`} onClick={() => { navigateToScreens("active") }}>{clock}Active Bids</Button>
                            </div>
                            <div className="btn-resp-bids">
                                <Button variant={activeBtnType == "won" ? 'secondary' : 'outline-steel'} className={`${activeBtnType == "won" ? 'bids-btn-active' : ''} head-btn`} onClick={() => { navigateToScreens("won") }}>{medal}Won Bids</Button>
                            </div>
                            <div className="btn-resp-bids">
                                <Button variant={activeBtnType == "notwon" ? 'secondary' : 'outline-steel'} className={`${activeBtnType == "notwon" ? 'bids-btn-active' : ''} head-btn`} onClick={() => { navigateToScreens("notwon") }}>{lostface}Lost Bids</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                loading ?
                    <div className={`d-flex justify-content-center h-100 align-items-center mt-3`}>
                        <div className="large-screen-width">
                            <div className="loader d-flex align-items-center justify-content-center h-100">
                                <img src={`${process.env.PUBLIC_URL}/static/icons/table/loader.gif`} className="loader-icon" alt="loader-icon"></img>
                            </div>
                        </div>
                    </div> :
                    <div className="w-100" ref={scrollRef} onScroll={handleScroll} style={{ ...props.style }}>
                        <div className={`d-flex align-items-center h-100 justify-content-center`}>
                            <div className="large-screen-width">
                                {activeBtnType == "active" ?
                                    <Bidding {...props} />
                                    : '' }

                                    { activeBtnType == "won" ?
                                        <WonAndNotWonDatatable page={"won"}{...props} getItemsList={getItemsList} deleteItemsList={deleteItemList}
                                            stateMaintenance={stateMaintenance}></WonAndNotWonDatatable>
                                        : '' }
                                        
                                        { activeBtnType == "notwon" ?
                                            <WonAndNotWonDatatable page={"not-won"}{...props} getItemsList={getItemsList} deleteItemsList={deleteItemList}
                                                stateMaintenance={stateMaintenance}></WonAndNotWonDatatable> : ''}
                            </div>
                        </div>
                    </div>

            }
        </div>
    )

}

class MyBids extends Component {
    constructor(props) {
        super(props);
    }


    render() {
        return <MyBidsFn {...this.props} />
    }
}

export default connect(state => state)(MyBids);